module.exports = __webpack_public_path__ + "d81c78e2d4ac105f8f30603b88ddee60.png";